import { Injectable, signal, computed } from '@angular/core';

export type DeliveryMode = 'CIF' | 'FOB';
export type PaymentMethod = 'PIX' | 'CREDIT_CARD' | 'BOLETO';

export interface FobVehicleInfo {
  plate: string;
  vehicleSize: string;
  brand: string;
  model: string;
  driverName: string;
  phone: string;
  pickupDate: string;
}

@Injectable({
  providedIn: 'root',
})
export class CheckoutStateService {
  deliveryMode = signal<DeliveryMode | null>(null);
  paymentMethod = signal<PaymentMethod | null>(null);
  fobVehicleInfo = signal<FobVehicleInfo | null>(null);
  fobFormValid = signal<boolean>(false);
  paymentFormValid = signal<boolean>(false);
  deliveryAddressValid = signal<boolean>(false);

  isFob = computed(() => this.deliveryMode() === 'FOB');

  setDeliveryMode(mode: DeliveryMode) {
    this.deliveryMode.set(mode);
    if (mode === 'CIF') {
      this.fobVehicleInfo.set(null);
      this.fobFormValid.set(false);
    }
  }

  setPaymentMethod(method: PaymentMethod) {
    this.paymentMethod.set(method);
    // PIX não tem formulário, já é válido por definição
    this.paymentFormValid.set(method === 'PIX');
  }

  setPaymentFormValid(valid: boolean) {
    this.paymentFormValid.set(valid);
  }

  setFobVehicleInfo(info: FobVehicleInfo, isValid: boolean) {
    this.fobVehicleInfo.set(info);
    this.fobFormValid.set(isValid);
  }

  setDeliveryAddressValid(valid: boolean) {
    this.deliveryAddressValid.set(valid);
  }
}
